(function () {
	"use strict";
	var $ = avm.require("cash"),
	$techcornerTrigger = $(".js-techcorner-toggler"),
	$techcorner = $(".js-techcorner"),
	$techcornerHeaders = $(".js-techcorner-header");

	//techcorner
	$techcornerTrigger.on("click", function(e) {
		var $currentTechcorner = $(this).closest($techcorner),
			$currentTechHeader = $currentTechcorner.children(".js-techcorner-header").first();

		e.preventDefault();
		$techcornerHeaders.removeAttr("tabIndex");

		if (!$currentTechcorner.hasClass("expanded")) {
			$currentTechcorner.addClass("expanded").attr("aria-expanded", "true");

			$currentTechHeader.attr("tabIndex", -1).trigger("focus");
		} else {
			$currentTechcorner.removeClass("expanded").attr("aria-expanded", "false");
		}
	});
})();
